import React from 'react'
import List from './List'

const Posts = ({ posts }) => {
    return (
        <section>
            <List posts={posts} />
        </section>
    )
}

export default Posts